<!-- https://www.figma.com/file/hZ14djvbx5qYuIJwSU7moW/%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-%F0%9F%94%A5?node-id=981%3A102603 -->
<template>
  <div class="product-slide">
    <BHLink
      class="product-slide__picture-link"
      :href="product.url"
      target="_blank"
      @click="onClickProduct()"
    >
      <div class="product-slide__picture-wrapp">
        <BasePicture
          class="product-slide__picture"
          :alt="image?.alt || ''"
          :sizes="sizes"
          :origin="fullSizeUrl"
          @click="$emit('open-image', fullSizeUrl)"
          @load="hidePlaceholder"
        />
        <LazyloadPlaceholder
          v-if="!loaded"
          class="product-slide__lazyload-placeholder"
        />
      </div>
    </BHLink>

    <BHLink
      v-if="isShowCaption"
      class="product-slide__caption"
      :href="product.url"
      target="_blank"
      @click="onClickProduct()"
    >
      {{ caption }}
    </BHLink>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import LazyloadPlaceholder from '~/components/LazyloadPlaceholder.vue';
  import type { TImage, TImageSize, TPictureSource } from '~/types/common';
  import type { TGalleryProductItem } from '~/types/components/Gallery';
  import getSlugFromUrl from '~/utils/getSlugFromUrl';
  import BHLink from '~/components/BHLink.vue';
  import BasePicture from '@devhacker/shared/features/BasePicture/BasePicture.vue';
  export default defineNuxtComponent({
    name: 'ProductSlide',

    components: {
      BasePicture,
      BHLink,
      LazyloadPlaceholder,
    },

    inject: {
      // Категория в которой происходит событие
      // Для аналитики
      eventCategory: {
        default() {
          return () => '';
        },
      },
    },

    props: {
      product: {
        type: Object as PropType<TGalleryProductItem>,
        required: true,
      },
    },

    data: () => ({
      loaded: false,
      sources: [
        {
          sizes: ['(max-width: 1023px) 100vw', '(min-width: 1024px) 732px'],
        },
      ] as TPictureSource[],
    }),

    computed: {
      image(): TImage | null {
        return this.product.image;
      },

      sizes(): TImageSize[] {
        return this.image?.sizes || [];
      },

      caption(): string {
        return this.product.label;
      },

      isShowCaption(): boolean {
        return Boolean(this.caption && this.caption.length > 0);
      },

      fullSizeUrl(): string {
        return this.image?.origin || '';
      },

      currentSlug(): string {
        return getSlugFromUrl(useRoute().fullPath);
      },
    },

    methods: {
      hidePlaceholder(): void {
        this.loaded = true;
      },

      onClickProduct(): void {
        // Аналитика клика на товарный блок
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '~/scss/gallery/Gallery.mixins.scss' as *;

  .product-slide {
    $product-slide: &;

    @include hover {
      #{$product-slide} {
        &__picture {
          :deep() .picture__img {
            transform: scale(1.1);
          }
        }

        &__picture-link {
          &::before {
            border-color: #83218d;
          }

          &::after {
            border-color: white;
          }
        }

        &__caption {
          color: #83218d;
        }
      }
    }

    &__picture-wrapp {
      position: relative;

      &::before {
        content: '';
        display: block;
        // --aspect-ratio назначается в стилях Gallery.vue и миксинах Gallery.mixins.scss
        padding-top: calc(100% / var(--aspect-ratio));
      }
    }

    &__picture-link {
      display: block;
      position: relative;
      border-radius: 32px;
      overflow: hidden;
      z-index: 5;

      &:deep() .link-content {
        // Fallback for browsers that don't support :has()
        display: inline;
      }

      &::before,
      &::after {
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border-radius: 32px;
        border: 4px solid transparent;
        z-index: 1;
      }

      &::after {
        left: 4px;
        top: 4px;
        right: 4px;
        bottom: 4px;
        border-radius: 28px;
        border: 4px solid transparent;
        z-index: 2;
      }
    }

    &__picture,
    &__lazyload-placeholder {
      position: absolute !important;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border-radius: 32px;
      overflow: hidden;
      cursor: pointer;
      :deep() .picture__img {
        object-fit: cover;
        height: 100%;
        transition: transform 0.3s;
        will-change: transform;
      }
    }

    &__lazyload-placeholder {
      cursor: default;
    }

    &__caption {
      display: block;
      padding-top: $spacing-2;
      @include caption;
      text-align: center;
      color: #c722ca;

      @include hover {
        color: #83218d;
      }
    }
  }
</style>
